
import agora_rtc_sdk_ng from 'agora-rtc-sdk-ng';
import agora_rtm_sdk from 'agora-rtm-sdk';


const XM_DEPENDENCIES3 = {
  agora_rtc_sdk_ng,
  agora_rtm_sdk,
};

for (let name in XM_DEPENDENCIES3){
  if (XM_DEPENDENCIES3.hasOwnProperty(name)){
    window[`XM_DEPENDENCIES_${name}`] = XM_DEPENDENCIES3[name];
  }
}

if (window.XM_DEPENDENCIES2) {
  window.XM_DEPENDENCIES2 = XM_DEPENDENCIES3;
} else {
  window.XM_DEPENDENCIES2 = {...XM_DEPENDENCIES3, ...window.XM_DEPENDENCIES2}
}


export {
  agora_rtc_sdk_ng,
  agora_rtm_sdk,
}
